import ChatComponent from "../../lib/ChatComponent";

const Attivita = () => {
  return (
    <div>
      <ChatComponent />
    </div>
  );
};

export default Attivita;
